<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span>
        <el-row class="chevereFooter">            
            <img class="CanvasImgFooter" src="@/../public/assets/images/identidad/footer1.png" alt="ChevereTech" title="ChevereTech">
            <div class="row">
                <a href="https://www.facebook.com/ChevereTech/" target="_blank" class="ChevereFbButton redesButton"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }" style="font-size:36px;"  /></a>
                <a title="Twitter" href="https://twitter.com/techchevere" target="_blank" class="ChevereTwButton redesButton"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" style="font-size:36px;"  /></a>
                <a href="https://www.instagram.com/cheveretech/" target="_blank" class="ChevereIgButton redesButton"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" style="font-size:36px;"  /></a>
            </div>                      
        </el-row> 
        <el-row class="chevere-data">
            <el-col :lg="8" :xs="24" >
                Conoce nuestras <router-link to='/politicas'>Políticas de privacidad</router-link>
            </el-col>
            <el-col :lg="8" :xs="24" >
                Escribenos a <a href="mailto:soporte@chevere.tech">soporte@chevere.tech</a>
            </el-col>
            <el-col :lg="8" :xs="24" >
                Háblanos al +51 919 006 885 / +51 928 654 938
            </el-col>
        </el-row> 
        <div class="ChevereCopyright">
            &copy; Copyright 2020<strong> ChevereTech!</strong>. Todos los derechos reservados<br>
        </div>       
    </span>
</template>

<script>

export default {
    name: "myfooter",    
}
</script>

<style scoped>
.chevere-data{
    color:white;
    background-image: linear-gradient(-90deg, #3b0a27, rgb(33, 8, 66));
    
    font-size: 15px;
}

.chevereFooter{
    height: 50vh;
    background-image: linear-gradient(-90deg, #3b0a27, rgb(33, 8, 66));
    margin-top: 25px;
}
.CanvasImgFooter {
    position: absolute;
    bottom: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
}
.CanvasTextFooter {
    position: absolute;
    bottom: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    text-align: center;
}

.redesButton{
    text-decoration:none;
    background-color: #f0f0f000;
    color: white;
    border: 2px solid white;
    border-radius: 15px;
    padding-right: 15px;
    padding-left: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 15px;
    position: absolute;
    cursor: pointer;
}
.ChevereFbButton {   
    bottom: 40%;
    left: 30%;
    transform: translate(-50%, -50%);
}

.ChevereFbButton:hover {
    color: #3b5998;
    border: 2px solid #3b5998;
}

.ChevereTwButton {   
    bottom: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.ChevereTwButton:hover {
    color: #00ACEE;
    border: 2px solid #00ACEE;
}

.ChevereIgButton {    
    bottom: 40%;
    left: 70%;
    transform: translate(-50%, -50%);
}
.ChevereIgButton:hover {
    color: #cd486b;
    border: 2px solid #cd486b;
}
.ChevereCopyright{
    bottom: 0;
    height: 20px;
    padding-top:10px;
    background-image: linear-gradient(-90deg, #3b0a27, rgb(33, 8, 66));
    background-position: 50% 50%;
    width: 100%;
    text-align: center;
    font-size: 15px;
    color: white;
}

@media only screen and (max-width: 1400px) {
 .ChevereIgButton{
    bottom: 10%;
  }
  .ChevereFbButton{
    bottom: 10%;
  }
  .ChevereTwButton{
    bottom: 10%;
  }
  .CanvasImgFooter {
    bottom: 25%;
    left: 50%;
    width: 30%
  }
  .ChevereCopyright{
      font-size: 10px;
  }
}

@media only screen and (max-width: 540px) {
  .redesButton{
      width:80%;
  }
  .ChevereIgButton{
    bottom: 5%;
    left: 50%;
  }
  .ChevereFbButton{
    bottom: 25%;
    left: 50%;
  }
  .ChevereTwButton{
    bottom: 45%;
    left: 50%;
  }
  .CanvasImgFooter {
    bottom: 65%;
    left: 50%;
    width: 40%
  }
  .ChevereCopyright{
      font-size: 10px;
  }
}
</style>





// WEBPACK FOOTER //
// src/sections/Footer.vue